import { createContext } from 'react';

import { Context } from './Modes.types';

export const context = createContext<Context>({
  list: [],
});
